import { render } from "./LoadingContentComponent.vue?vue&type=template&id=6295082e"
import script from "./LoadingContentComponent.vue?vue&type=script&lang=js"
export * from "./LoadingContentComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/frontend/components/LoadingContentComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6295082e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6295082e', __exports__)) {
    api.reload('6295082e', __exports__)
  }
  
  module.hot.accept("./LoadingContentComponent.vue?vue&type=template&id=6295082e", () => {
    api.rerender('6295082e', render)
  })

}


export default __exports__